
import FiltroPeriodo from "./FiltroPeriodo.vue";

export default {
  name: "RelacaoFinanceira",
  components: { FiltroPeriodo },

  props: {
    dados: {
      type: Object,
      default: () => ({ data: { series: [], categories: [] } }),
    },

    // Período atual (pode ser null no boot)
    periodo: { type: Object, default: null },

    // Estado de carregamento
    loading: { type: Boolean, default: false },

    // Evita emitir @apply no mount
    ignoreInitialApply: { type: Boolean, default: true },
  },

  computed: {
    categories() {
      return this.dados?.data?.categories ?? [];
    },
    rawSeries() {
      return Array.isArray(this.dados?.data?.series)
        ? this.dados.data.series
        : [];
    },

    chartSeries() {
      // Define tipo e cor por nome da série
      const colorByName = {
        Receitas: "#2ECC71",
        Despesas: "#E74C3C",
        Total: "#3498DB",
      };

      return this.rawSeries.map((s) => {
        const name = s?.name || "";
        const isTotal = name.toLowerCase() === "total";
        return {
          name,
          data: Array.isArray(s?.data) ? s.data : [],
          type: isTotal ? "line" : "bar",
          color: colorByName[name] || (isTotal ? "#3498DB" : undefined),
        };
      });
    },

    chartOptions() {
      return {
        chart: { toolbar: { show: false } },
        xaxis: { categories: this.categories },
        yaxis: {
          labels: {
            formatter: (v) =>
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 0,
              }).format(v || 0),
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            borderRadiusApplication: "end",
            columnWidth: "60%",
          },
        },
        stroke: { curve: "smooth", width: 3 },
        tooltip: {
          y: {
            formatter: (v) =>
              new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(v || 0),
          },
        },
        legend: { show: true },
      };
    },
  },

  methods: {
    onApplyPeriodo({ inicio, fim }) {
      this.$emit("change-periodo", { inicio, fim });
    },
  },
};
